import { ReactNode } from 'react';
import { useController, UseControllerProps, useFormContext } from 'react-hook-form';

import { PhoneInput, PhoneInputProps } from '../phone-input/PhoneInput';

type Props = PhoneInputProps & {
  name: UseControllerProps['name'];
  countryName: UseControllerProps['name'];
  rules?: UseControllerProps['rules'];
  defaultValue?: UseControllerProps['defaultValue'];
  renderSibling?: (_value: string) => ReactNode;
};

export const PhoneInputControlled = ({ name, countryName, defaultValue = '', rules, ...rest }: Props) => {
  const { control } = useFormContext();

  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  const countryController = useController({ name: countryName, control, defaultValue: 'fr' });

  return (
    <PhoneInput
      {...rest}
      errorMessage={error?.message}
      onChange={data => {
        onChange(data.phone);
        countryController.field.onChange(data.country);
      }}
      value={value}
    />
  );
};
